import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminBrandContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeEdited!: boolean;

  @jsonMember(Boolean)
  public readonly canBeDeleted!: boolean;

  @jsonMember(Boolean)
  public readonly canBeViewed!: boolean;
}
